const Paths = {
  Default: "/",
  Home: "/",
  Error: "/error",
  NotFound: "/not-found",
  Forbidden: "/forbidden",
  Redirect: "/redirect",
  User: "/people/:userId",
  UserMeetings: "/people/:userId/meetings",
  UserStrategy: "/people/:userId/strategy",
  UserImplementation: "/people/:userId/implementation",
  UserFeedback: "/people/:userId/feedback",
  UserFeedbackDetails: "/feedback/:formSubmissionGuid",
  UserMetrics: "/people/:userId/metrics",
  UserSettings: "/settings",
  UserNotifications: "/notifications",
  RoleDetails: "/roles/:roleGuid",
  Team: "/teams/:slug",
  TeamImplementation: "/teams/:slug/implementation",
  TeamStrategicMap: "/teams/:slug/strategic-map",
  TeamMeetings: "/teams/:slug/meetings",
  TeamMetrics: "/teams/:slug/metrics",
  TeamResources: "/teams/:slug/resources",
  TeamSettings: "/teams/:slug/settings",
  ActionItemDetails: "/strategic-items/:actionItemGuid",
  TaskItemDetails: "/task-items/:taskItemGuid",
  IssueDetails: "/loops/:issueGuid",
  IssueDetailsLegacy: "/issues/:issueGuid",
  Meeting: "/meetings/:meetingGuid",
  MetricDetails: "/metrics/:metricGuid",
  SignOut: "/sign-out",
  Search: "/search",
  Chat: "/chat",
  Reports: "/reports",
  OrganizationReport: "/reports/organization-report",
  CoherenceReport: "/reports/coherence-report",
  AppUsageReport: "/reports/app-usage-report",
  EmployeeFeedbackReport: "/reports/employee-feedback-report",
  Surveys: "/surveys",
  Survey: "/surveys/:guid",
  SurveyResponses: "/surveys/:guid/responses",
  SurveyActions: "/surveys/:guid/actions",
  SurveyResponse: "/surveys/:guid/response",
  Wiki: "/wiki/:slug",
  Guide: "/code-os-guide",
  SignedOut: "/signed-out",
};

export { Paths };
